<!-- Layout für eine Linkliste-->
@if (listview && listview.totalCount > 0) {
  <div class="layoutBlock">
    <div class="listviewBadgeLeft">
      <div class="circleIconContainer">
        <div class="circle-icon">
          <div><img hisImage="{{ listview.icon }}" class="inlineicon"
          title="{{ getTranslation('title', listview) }}"></div>
        </div>
      </div>
    </div>
    <div class="listviewSideRight">
      <div class="citation">
        <h2>{{ getTranslation('title', listview) }} ({{ listview.totalCount }})</h2>
        <ul class="listSimple">
          @for (entry of listview.listViewData; track entry) {
            <li>
              @if (entry.viewUrl) {
                @if (isSameRouterContext(entry.viewUrl)) {
                  <a (click)="onBeforeNavigate()"
                    [routerLink]="[getRouterLinkUrl(entry.viewUrl)]" [queryParams]="{showBackButton: true}"
							title="{{ entry.viewUrlTooltip ? getTranslation('viewUrlTooltip', entry) : 
							('common.showOf'|hisUi : ( entry.secondaryDetails ? getSecondaryDetails(entry) : 
							(getTranslation('nameTitle', entry).split(':')[0]  + ' '+ getTranslation('objectName', entry) ))) }}">
                    <his-translated-text [hisobject]="entry" [hisAttribute]="'objectName'">
                    </his-translated-text>
                  </a>
                } @else {
                  <a href="{{entry.viewUrl}}?showBackButton=true{{getQueryParamShowSearchButton(entry)}}"
                    (click)="onBeforeNavigate()"
								title="{{ entry.viewUrlTooltip ? getTranslation('viewUrlTooltip', entry) : 
						    ('common.showOf'|hisUi : ( entry.secondaryDetails ? getSecondaryDetails(entry) : 
                            (getTranslation('nameTitle', entry).split(':')[0]  + ' '+ getTranslation('objectName', entry) ))) }}">
                    <his-translated-text [hisobject]="entry" [hisAttribute]="'objectName'">
                    </his-translated-text>
                  </a>
                }
              } @else {
                <his-translated-text [hisobject]="entry" [hisAttribute]="'objectName'"></his-translated-text>
              }
              @if (!entry.detailsObject?.title) {
                <div class="small">{{ getTranslation('details', entry ) }}</div>
              }
              @if (entry.detailsObject?.title) {
                <div class="small">
                  @if (entry.detailsObject.prefix) {
                    <span
                    >{{ getTranslation('prefix', entry.detailsObject ) }}</span>
                  }
                  <his-translated-text [hisobject]="entry.detailsObject" [hisAttribute]="'title'">
                  </his-translated-text>
                  @if (entry.detailsObject.suffix) {
                    <span
                    >{{ getTranslation('suffix', entry.detailsObject ) }}</span>
                  }
                </div>
              }
              @if (entry.secondaryDetails) {
                <div class="small">{{ getTranslation('secondaryDetails', entry ) }}
                </div>
              }
            </li>
          }
        </ul>
        @if (listview.totalCount > 3 && listview.searchQueryParams) {
            <a (click)="moreEntriesClicked($event)" class="transparent" hisImage="next"
            href="{{getHrefForMoreEntries(listview)}}"
            title="{{'fs.res.common.showAllAssignedObjects'| hisUi : (getTranslation('title', listview)|hisLowerCaseFirstLetter) }}">
               <span>{{ 'common.more' | hisUi }}</span>
           </a>
        }
      </div>
    </div>
  </div>
}
